import { Route } from 'RestAPIs/travel-distances/types';

import { displayNumber } from 'utils/misc';

import { Dialog, LoadingOverlay } from 'components/shared';

import { getAddressAsString } from '../util';
import { lazy, Suspense } from 'react';

type Props = {
  route: Route;
  isOpen: boolean;
  onClose: () => void;
};

const TravelDistanceMapDialog = ({ route, isOpen, onClose }: Props) => {
  const LazyMapView = lazy(() => import('./MapView'));

  const onClickCancel = () => {
    onClose();
  };

  return (
    <Dialog
      open={isOpen}
      title={
        route
          ? getAddressAsString(route.departureAddress) +
            ' - ' +
            getAddressAsString(route.destinationAddress) +
            ' (' +
            displayNumber(route.distanceInMeters / 1000, 1) +
            'km)'
          : ''
      }
      handleClose={onClickCancel}
      fullWidth={true}
      maxWidth="extralarge"
      slotProps={{
        paper: {
          sx: {
            width: '100%',
            height: '100%'
          }
        }
      }}
    >
      <Suspense fallback={<LoadingOverlay loading={true} />}>
        <LazyMapView route={route} />
      </Suspense>
    </Dialog>
  );
};

export default TravelDistanceMapDialog;
